/**
 * Emit HCR widget markers
 * @param markers available are fn,cs
 * @see https://quip-amazon.com/TLkwAzdmAbgc/Client-Side-Page-Latency-Guidance-for-Clinic#temp:C:GEG7d21d7e8a5104bca9bbed61f8
 */
const emitMarkersForWidget = function (widgetElement: HTMLElement | undefined) {
    if (!widgetElement) {
        return;
    }
    const csa = (window as any).csa;
    if (!csa) {
        console.warn('csa does not exist');
        return;
    }
    const csaFun = csa('PageTiming');
    // We only support page level latency for now.
    // TODO support content level latency in future.
    // https://issues.amazon.com/issues/KATARA-SX-6456
    const markers = (widgetElement.dataset.widgetCsaMarker || '').split(',');
    if (markers.indexOf('fn') >= 0) {
        emitMarker(csaFun, 'functional')
    }
    if (markers.indexOf('cf') >= 0) {
        emitMarker(csaFun, 'criticalFeature')
    }
}

const emitMarker = function (csaFun: any, marker: string) {
    try {
        csaFun('mark', marker)
    } catch (error) {
        // do not block functionality.
        console.error(error);
    }
}

export { emitMarkersForWidget }